

















































import {Component, Emit, Vue} from 'vue-property-decorator';
import contentsModule from '@/model/store/modules/contents-module';
import userModule from '@/model/store/modules/user-module';
import appModule from '@/model/store/modules/app-module';
import menuModule from '@/model/store/modules/menu-module';
import aboutModule from '@/model/store/modules/about-module';
import viewerService from '@/model/services/viewer-service';
import CategoryChips from '@/components/molecules/CategoryChips.vue';
import _ from 'lodash';

@Component({
  components: {
    'category-chips': CategoryChips
  }
})
export default class RightViewer extends Vue {
  /** Data **/
  private items = [
        { title: 'Home', subtitle: 'ホーム',  icon: 'home' },
        { title: 'Menu', subtitle: 'メニュー', icon: 'mdi-menu' },
        { title: 'About', subtitle: 'お店について', icon: 'mdi-help-box' },
      ];
  /** Computed **/
  get isLogin() {
    return userModule.userName !== '' && appModule.token !== '';
  }

  set asideNavi(val: boolean) {
    contentsModule.pushIsAside(val);
  }

  get asideNavi() {
    return contentsModule.isAside;
  }

  get innerWidth() {
    return contentsModule.innerWidth > 1000 ? window.innerWidth / 4 : 325;
  }

  /** Mutations **/

  /** Refs **/

  /** Methods **/
  private async onClick(v: string) {
    switch (v) {
      case this.items[0].title:
        await appModule.requestCategoryInfo({
          q: appModule.searchKeyword !== '' ? appModule.searchKeyword : '',
          s: 0,
          o: 'dp'
        })
        .catch(err => {
          this.errorPropagation(err);
        });
        this.$router.push({ path: '/'}).catch(err => err);
        break;
      case this.items[1].title:
        await menuModule.requestMenuInfo(1)
        .catch(err => {
          this.errorPropagation(err);
        });
        this.$router.push({ path: '/menu/'}).catch(err => err);
        break;
      case this.items[2].title:
        await aboutModule.requestAboutInfo(1)
        .catch(err => {
          this.errorPropagation(err);
        });
        this.$router.push({ path: '/about/'}).catch(err => err);
        break;
    }

  }

  // エラーの伝搬
  @Emit('error')
  private errorPropagation(err: Error): Error {
    console.log(err);
    return err;
  }

  /** LifeCycle **/

  private async mounted() {

  }

}
